import { useContext } from 'react'

import { CurrencyAreaContext } from './CurrencyAreaContext'

export const useCurrencyAreaContext = () => {
  const { currencyArea } = useContext(CurrencyAreaContext)

  return currencyArea
}
